import CheckCircleIcon from "@redotech/redo-icons/check-circle_filled.svg";
import { ProcessReturnStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

export interface ProcessReturnNodeData {
  step: PartialWithRequiredType<ProcessReturnStep>;
  deleteElements: (id: string) => void;
  hovered?: boolean;
}

export const ProcessReturnNode = memo(function ProcessReturnNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: ProcessReturnNodeData;
  selected?: boolean;
}) {
  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        hovered={data.hovered}
        icon={
          <RedoFeaturedIcon
            color="success"
            Icon={CheckCircleIcon}
            shape="circle"
            size="md"
          />
        }
        onDelete={() => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title="Process return"
      />
      <Handle position={Position.Bottom} type="source" />
    </>
  );
});
